/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { ParametresGeneraux } from '@/types';

type ParametresStoreType = {
  parametres: ParametresGeneraux;
  setParametres: (parametres: ParametresGeneraux) => void;
};

const useParametresStore = create<ParametresStoreType>()(
  devtools((set) => ({
    parametres: null,
    setParametres: (parametres) => set({ parametres }),
  })),
);

export default useParametresStore;
